import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import "./index.css";
import {
  ThemeProvider,
  createTheme,
  responsiveFontSizes,
  StyledEngineProvider
} from "@mui/material/styles";
import themeJson from "style/theme";
import { msalInstance, initializeMsal, handleMsResponse } from "config/msconfig";
import App from "./app";
// import reportWebVitals from "./reportWebVitals";
import "./i18n";

// Microsoft Sign In should be init here, and it can be init only once and outside the component
// I didn't put it into index.tsx, just want to consolidate the sign in code to this file
let initialized = false;
if (!initialized) {
  initializeMsal()
    .then(() => {
      initialized = true;
      // microsoft sign in, init
      msalInstance
        .handleRedirectPromise()
        .then(handleMsResponse)
        .catch((error) => {
          console.log("msalInstance error:", error);
          // setAlertInfo({ open: true, message: t("error.fail-to-login") });
        });
      console.log("MSAL initialized");
    })
    .catch((error) => {
      console.error("MSAL initialization failed:", error);
    });
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);
let theme = createTheme(themeJson);
theme = responsiveFontSizes(theme);

const Loader = () => {
  return <div>loading...</div>;
};

root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        {/* <Provider store={store}> */}
        <Suspense fallback={<Loader />}>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </Suspense>
        {/* </Provider> */}
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
